import { CommunicationChannelEmailV1SubTypeEnum, CommunicationChannelPhoneV1SubTypeEnum } from 'target/user';
export const mapToUserProfile = (modelUser) => {
    var _a, _b, _c, _d, _e;
    const modelName = modelUser.profile.name;
    const emailCommunicationChannel = modelUser.profile.communicationMethods.find((method) => method.subType === CommunicationChannelEmailV1SubTypeEnum.Email);
    const phoneCommunicationChannel = modelUser.profile.communicationMethods.find((method) => method.subType === CommunicationChannelPhoneV1SubTypeEnum.Phone);
    return {
        status: modelUser.status,
        username: modelUser.profile.login,
        email: (_a = emailCommunicationChannel === null || emailCommunicationChannel === void 0 ? void 0 : emailCommunicationChannel.email) !== null && _a !== void 0 ? _a : '',
        prefix: modelName.prefix,
        firstName: (_b = modelName.givenNames) === null || _b === void 0 ? void 0 : _b.at(0),
        middleName: (_c = modelName.givenNames) === null || _c === void 0 ? void 0 : _c.at(1),
        lastName: modelName.familyName,
        suffix: modelName.suffix,
        locale: modelUser.profile.locale,
        countryCode: (_d = phoneCommunicationChannel === null || phoneCommunicationChannel === void 0 ? void 0 : phoneCommunicationChannel.phone.countryCode) === null || _d === void 0 ? void 0 : _d.code,
        areaCode: (_e = phoneCommunicationChannel === null || phoneCommunicationChannel === void 0 ? void 0 : phoneCommunicationChannel.phone.areaCode) === null || _e === void 0 ? void 0 : _e.code,
        phoneNumber: phoneCommunicationChannel === null || phoneCommunicationChannel === void 0 ? void 0 : phoneCommunicationChannel.phone.number
    };
};
